import { gsap } from 'gsap';
//import { indexOf as _indexOf } from 'underscore';
//import Cookies from 'js-cookie';

export default class overlayMessage{

    constructor(options) {

        this.defaults = {
        	main 			: undefined,
        	$el   			: $( '.overlay-message' )
        }
        this.options = {};
		Object.assign(this.options, this.defaults, options);

		this.namespace 		= 'overlay-message';
		this.main			= this.options.main;
		this.$el 			= this.options.$el;
		
		this.init();
    }

    init(){
    	if ( this.$el.length > 0 ){
    		this.$el.find( '.close.icon' ).on( 'click', ()=>{
    			this.closeOverlayMessage()
    		});
            this.initAutoHide(true);
            this.$el.on( 'mouseenter', ()=>this.initAutoHide(false) );
    	}
    }

    initAutoHide( b ){
        if ( this.$el.hasClass( 'autohide' ) ){

            //console.log( 'initAutoHide, b = ' + b );
            if ( b ){
                this.timeout_autohide = setTimeout( ()=>{
                    
                    this.closeOverlayMessage();

                }, parseFloat( this.$el.attr( 'data-time-autohide' ) )*1000 );
            }
            else{
                clearTimeout( this.timeout_autohide );
            }

        }
    }

    closeOverlayMessage(){
    	gsap.to( this.$el.find( '.inner' ), {opacity:0, ease:'power2.out',duration:1, onComplete:()=>{this.onCloseEnd()} } );
    }

    onCloseEnd(){
    	setTimeout( ()=>{ $('.video-container-home').removeClass( 'has-overlay-message' ) }, 200 );
    	this.remove();
    }

    remove(){
    	this.$el.remove();
    }

    destroy(){
    	if ( this.$el.length > 0 ){
    		this.$el.find( '.close.icon' ).off( 'click', ()=>{
    			this.closeOverlayMessage()
    		});
    	}
     }

}
